import { Dispatch, createContext, useContext } from "react";

import { Action } from "../../../types/reducer-action";
import { IValueInfo, IValueInfoInput } from "../../../types/valuelist";
import { trimToEmpty } from "../../../utils/commons";
import { DataEntryState, dataEntryReducer } from "../../common/data-entry-reducer";

export interface ValueInfoForm extends IValueInfo {
  parentId: number;
}

export interface ValueListState extends DataEntryState<IValueInfo, ValueInfoForm> {
  currentValueGroup?: string;
  sortedItems?: IValueInfo[];
}

export const valueListReducer = (state: ValueListState, action: Action): ValueListState =>
  dataEntryReducer<IValueInfo, ValueInfoForm>(state, action);

export const ValueListContext = createContext<ValueListState>({} as ValueListState);
export const useValueListState = () => useContext(ValueListContext);

export const ValueListDispatchContext = createContext<Dispatch<Action>>(() => { });
export const useValueListDispatch = () => useContext(ValueListDispatchContext);

export const toValueInfoInput = (form?: ValueInfoForm) => form ?
  {
    type: trimToEmpty(form.type),
    code: trimToEmpty(form.code),
    label: trimToEmpty(form.label),
    label2: trimToEmpty(form.label2),
    lang: trimToEmpty(form.lang),
    level: trimToEmpty(form.level),
    metadata: trimToEmpty(form.metadata),
    abbr: trimToEmpty(form.abbr),
    comment: trimToEmpty(form.comment),
    desc: trimToEmpty(form.desc),
    active: form.active ?? true,
    displayOrder: +form.displayOrder,
    parentId: form.parentId ?? form.parent?.id ?? 0
  } as IValueInfoInput
  : undefined;
